module.exports = __webpack_public_path__ + "static/media/logo-픽셀릭코리아@3x.5f64d395.png";